import React from 'react'
import "./aedmap.css"

import { useState } from 'react';
import { addAED } from './lib/api';
import { MapPin, Plus, X } from 'lucide-react';


export function AddAEDForm({ onAEDAdded, onClose }) {
  const [formData, setFormData] = useState({
    name: '',
    address: '',
    latitude: '',
    longitude: '',
    description: '',
    accessibility: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsSubmitting(true);

    try {
      await addAED({
        name: formData.name,
        address: formData.address,
        latitude: parseFloat(formData.latitude),
        longitude: parseFloat(formData.longitude),
        description: formData.description,
        accessibility: formData.accessibility,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString()
      });

      setFormData({
        name: '',
        address: '',
        latitude: '',
        longitude: '',
        description: '',
        accessibility: ''
      });

      onAEDAdded();
      onClose();
    } catch (err) {
      setError(err?.message || 'An error has occurred');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const getCurrentLocation = () => {
    if (!navigator.geolocation) {
      setError('Geolocation is not supported by your browser');
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        setFormData(prev => ({
          ...prev,
          latitude: position.coords.latitude.toFixed(6),
          longitude: position.coords.longitude.toFixed(6)
        }));
      },
      (error) => {
        setError('Unable to retrieve your location: ' + error.message);
      }
    );
  };

  return (
    <div className="aedform-overlay">
      <div className="aedform-modal">
        <div className="aedform-header">
          <h2>Add an AED</h2>
          <button
            onClick={onClose}
            className="aedform-close"
          >
            <X size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="aedform-body">
          {error && (
            <div className="aedform-error">
              {error}
            </div>
          )}

          <div className="aedform-group">
            <label>Place name *</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              className="aedform-input"
              placeholder="Ex: City Hall"
            />
          </div>

          <div className="aedform-group">
            <label>Address *</label>
            <input
              type="text"
              name="address"
              value={formData.address}
              onChange={handleChange}
              required
              className="aedform-input"
              placeholder="Ex: 123 Main St, City, Country"
            />
          </div>

          <div className="aedform-row">
            <div className="aedform-col">
              <label>Latitude *</label>
              <input
                type="number"
                name="latitude"
                value={formData.latitude}
                onChange={handleChange}
                required
                step="any"
                className="aedform-input"
                placeholder="48.8566"
              />
            </div>

            <div className="aedform-col">
              <label>Longitude *</label>
              <input
                type="number"
                name="longitude"
                value={formData.longitude}
                onChange={handleChange}
                required
                step="any"
                className="aedform-input"
                placeholder="2.3522"
              />
            </div>
          </div>

          <button
            type="button"
            onClick={getCurrentLocation}
            className="aedform-geo"
          >
            <MapPin size={16} />
            Use my current position
          </button>

          <div className="aedform-group">
            <label>Description</label>
            <textarea
              name="description"
              value={formData.description}
              onChange={handleChange}
              rows={3}
              className="aedform-textarea"
              placeholder="Additional information..."
            />
          </div>

          <div className="aedform-group">
            <label>Accessibility</label>
            <input
              type="text"
              name="accessibility"
              value={formData.accessibility}
              onChange={handleChange}
              className="aedform-input"
              placeholder="Ex: 24/7 access"
            />
          </div>

          <div className="aedform-actions">
            <button
              type="button"
              onClick={onClose}
              className="aedform-btn aedform-btn-secondary"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isSubmitting}
              className="aedform-btn aedform-btn-primary"
            >
              {isSubmitting ? 'Saving...' : 'Save'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
